import { gql } from '@apollo/client';

export default gql`
  mutation createMultiResourses($data: String) {
    createMultiResourses(data: $data) {
      ok
      message
      error
    }
  }
`;
